<template>
  <div>
    <el-row class="title-bar" type="flex" justify="space-between">
      <div class="vertical-center-box">
        <div class="title-h3 mr-r15">자동화 모델링 목록</div>
        <div class="setting-addel">
          <el-button size="mini" @click="onAddButtonClick"><i class="fas fa-plus"></i></el-button>
          <el-button size="mini" :disabled="!checkedRows.length" @click="onDeleteButtonClick"><i class="fas fa-minus"></i></el-button>
        </div>
      </div>
      <div class="vertical-center-box">
        <el-button class="mr-r4" type="primary" size="mini" :disabled="!checkedRows.length" @click="onModelingButtonClick">모델링</el-button>
        <w-header-search-button size="mini" @click="showSearchTool = !showSearchTool"></w-header-search-button>
      </div>
    </el-row>
    <el-row>
      <el-table-wrapper v-loading="isLoading" row-class-name="c-dblclick" :data="tableData" :columns="tableColumns" :column-default="columnDefault" ref="targetRangeTable"
        @selection-change="changeCheckedRow" :pagination="true" :show-search-tool="showSearchTool" :show-custom-header="true" @condition-change="changeTableCondition"
        @pagination-change="handlerPaginationChange" @total-change="handlerPaginationChange" @row-dblclick="onRowDblClick"
        remote :total="total">
        <template slot-scope="scope" slot="detail-slot">
          <span><i class="far fa-search-plus c-pointer" @click.stop="onClickDetailButton(scope.row)"></i></span>
        </template>
      </el-table-wrapper>
    </el-row>
    <!-- 자동화 모델링 설정 팝업 -->
    <w-ip-scan-range-setting-popup :selected-range="selectedRow" @re-load="loadData" ref="ipScanRangeSettingPopup"></w-ip-scan-range-setting-popup>
    <!-- 자동화 모델링 결과 팝업 -->
    <w-ip-scan-result-popup :selected-range="selectedRow" ref="ipScanResultPopup"></w-ip-scan-result-popup>
  </div>
</template>

<script>
import { cloneDeep } from 'lodash';
import { columnDefault, defaultPagination, defaultDetailHeaderColumn } from '@/constants/table';
import msgUtil from '@/utils/message';
import deviceRegistrationAmsAPI from '@/api/settings/common/device-registration-ams';
import WIpScanRangeSettingPopup from './popup/IpScanRangeSettingPopup';
import WIpScanResultPopup from './popup/IpScanResultPopup';

const pagination = cloneDeep(defaultPagination);

export default {
  name: 'WAmsModeling',
  components: {
    WIpScanRangeSettingPopup,
    WIpScanResultPopup,
  },
  data() {
    return {
      pagination,
      isLoading: false,
      columnDefault,
      total: 0,
      showSearchTool: false,
      selectedRow: null,
      checkedRows: [],
      tableData: [],
      tableColumns: [
        {
          // align: 'center',
          type: 'selection',
        },
        {
          prop: 'startIpaddress',
          label: '시작 IP',
          sortable: true,
          searchable: true,
          remoteProp: 'start_ipaddress',
        },
        {
          prop: 'endIpaddress',
          label: '종료 IP',
          sortable: true,
          searchable: true,
          remoteProp: 'end_ipaddress',
        },
        { ...defaultDetailHeaderColumn, label: '모델링 결과', width: 80, scopedSlot: 'detail-slot' },
      ],
    };
  },
  computed: {
    forceAmsModelingResultLoad() {
      return this.$store.state.ams.forceAmsModelingResultLoad;
    },
  },
  watch: {
    forceAmsModelingResultLoad: {
      immediate: true,
      handler(to) {
        if (to) {
          if (!this.isLoading) {
            this.loadData();
          }
          this.$store.dispatch('setForceAmsModelingResultLoad', false);
        }
      },
    },
  },
  methods: {
    loadData() {
      const params = this.$refs.targetRangeTable.getParameter();
      this.isLoading = true;
      deviceRegistrationAmsAPI.getAmsModelingRangeList(params).then((response) => {
        if (response.data.success) {
          this.tableData = response.data.data;
          this.total = response.data.total;
          this.isLoading = false;
        }
      }).catch(() => {
        this.isLoading = false;
      });
    },
    /**
     * [테이블 페이징] 페이지 변경 핸들러
     * @author Ju
     * @param  {Object} pagination 페이지 정보 객체
     */
    handlerPaginationChange(_pagination) {
      this.pagination = _pagination;
    },
    changeCheckedRow(selection) {
      this.checkedRows = selection;
    },
    changeTableCondition() {
      this.loadData();
    },
    /**
     * 추가 버튼 클릭
     * @author jeee12
     * @return {[type]} [description]
     */
    onAddButtonClick() {
      this.selectedRow = null;
      this.$nextTick(() => {
        this.$refs.ipScanRangeSettingPopup.open();
      });
    },
    /**
     * 모델링 수행 버튼 클릭
     * @author jeee12
     * @return {[type]} [description]
     */
    onModelingButtonClick() {
      this.$confirm(...msgUtil.getCustomConfirmData('모델링을 수행하시겠습니까?')).then(() => {
        deviceRegistrationAmsAPI.executeAmsModeling(this.checkedRows).then((response) => {
          if (response.data.success) {
            this.loadData();
            const rangeIds = this.checkedRows.map((e) => e.id);
            this.$store.dispatch('executeAmsModelingTask', rangeIds);
            this.$message(msgUtil.getCustomResultMsgData('모델링을 수행합니다. 대량 장비를 모델링 할 경우 시간이 다소 소요될 수 있습니다.', true));
          } else {
            this.$message(msgUtil.getResultMsgData('수행', '모델링', false));
          }
        }).catch((e) => {
          this.$message(msgUtil.getResultMsgData('수행', '모델링', false));
          throw e;
        });
      });
    },
    /**
     * 모델링 결과 보기
     * @author jeee12
     * @param  {[type]} row [description]
     * @return {[type]}     [description]
     */
    onClickDetailButton(row) {
      this.selectedRow = row;
      this.$nextTick(() => {
        this.$refs.ipScanResultPopup.open();
      });
    },
    /**
     * 삭제 버튼 클릭
     * @author jeee12
     * @return {[type]} [description]
     */
    onDeleteButtonClick() {
      this.$confirm(...msgUtil.getBasicConfirmData(msgUtil.action.DELETE)).then(() => {
        const target = '자동화 모델링 범위';
        const action = msgUtil.action.DELETE;
        deviceRegistrationAmsAPI.deleteAmsModelingRangeList(this.checkedRows).then((response) => {
          if (response.data.success) {
            this.loadData();
          }
          this.$message(msgUtil.getResultMsgData(action, target, response.data.success));
        }).catch(() => {
          this.$message(msgUtil.getResultMsgData(action, target, false));
        });
      }).catch(() => {});
    },
    onRowDblClick(row) {
      this.selectedRow = row;
      this.$nextTick(() => {
        this.$refs.ipScanRangeSettingPopup.open();
      });
    },
  },
};
</script>

<style module>
</style>



// WEBPACK FOOTER //
// src/views/settings/basic/DeviceRegistration/Server/AmsModeling.vue